module.exports = __webpack_public_path__ + "img/antes_despues_184.5f383aaf.png";